import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import footerInfo from '../../Content/Data/Footer/footer.json';
import navigationJson from '../../Content/Data/Navigation/navigation.json';
import servicesInfo from '../../Content/Data/Services/Info/info.json';
import contactUsJson from '../../Content/Data/ContactUs/contactUs.json';

function Footer(props) {

    const navigation = useRef(navigationJson.find(x => x.name.toLowerCase() === "services").subMenu);
    const [arrNavigation, setNavigation] = useState(getNavigationJson());
    const [arrServices, setServices] = useState(getServicesJson());

    function getNavigationJson() {
        return navigationJson.map(x => {
            if (x.subMenu && x.subMenu.length > 0) {
                let arrSubMenu = x.subMenu.map(y => {
                    if (y.subMenu && y.subMenu.length > 0) {
                        let arrSubMenu2 = y.subMenu.map(z => {
                            return {
                                ...z,
                            };
                        });
                        return {
                            ...y,
                            "subMenu": arrSubMenu2,
                        };
                    }
                    else {
                        return {
                            ...y,
                        };
                    }
                });
                return {
                    ...x,
                    "subMenu": arrSubMenu,
                };
            }
            else {
                return {
                    ...x,
                };
            }
        });
    }

    function getServicesJson() {
        let arrayOfArrays = [];
        for (let i = 0; i < servicesInfo.length; i += 5) {
            arrayOfArrays.push(servicesInfo.slice(i, i + 5));
        }
        return arrayOfArrays;
    }

    function handleNavclick(item) {
        props.setIsPathChanged(!props.isPathChanged);
    }

    function getClassNames(item) {
        let classNames = "";
        if (item.ClassNames && item.ClassNames.length > 0) {
            item.ClassNames.map(x => {
                classNames += x + " ";
            })
        }
        return classNames;
    }

    return (
        <div className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    {
                        footerInfo.Data.map((x, index) => {
                            return (
                                <div key={index} className={getClassNames(x)}>
                                    <div className='footer-block-title'>
                                        {x.Title}
                                    </div>
                                    {
                                        x.Services ?
                                            <div className='footer-services-container'>
                                                {
                                                    arrServices.map((arrService, arrServiceIndex) => {
                                                        return (
                                                            <div key={arrServiceIndex}>
                                                                {
                                                                    arrService.map((service, serviceIndex) => {
                                                                        let nav, subNav = null;
                                                                        nav = navigation.current.find(y => y.name === service.ServiceName);
                                                                        if (!nav) {
                                                                            nav = navigation.current.find(y => y.name === service.SubPartOf);
                                                                            subNav = nav.subMenu.find(y => y.name === service.ServiceName);
                                                                        }
                                                                        return (
                                                                            <div key={serviceIndex} className="footer-services-item">
                                                                                <Link
                                                                                    onClick={(event) => { handleNavclick(subNav || nav) }}
                                                                                    to={subNav ? `/services?a=${nav.to}&b=${subNav.to}` : `/services?a=${nav.to}`}>
                                                                                    {service.ServiceName}
                                                                                </Link>
                                                                            </div>
                                                                        );
                                                                    })
                                                                }
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                            :
                                            x.QuickLinks ?
                                                <div className='footer-quick-links-container'>
                                                    {
                                                        arrNavigation.filter(x => x.name.toLowerCase() !== "services").map((x, i) => {
                                                            return (
                                                                <div key={i}>
                                                                    <Link
                                                                        id={x.id}
                                                                        className={'footer-' + x.className}
                                                                        onClick={(event) => { handleNavclick(x) }}
                                                                        to={"/" + x.to}>
                                                                        {x.name}
                                                                    </Link>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                                :
                                                x.SetDynamic ?
                                                    <div key={index} className={getClassNames(x).trimEnd() + '-container'}>
                                                        <div dangerouslySetInnerHTML={{ __html: x.Content.replaceAll("{amatya-email}", contactUsJson.email) }} />
                                                    </div>
                                                    :
                                                    x.Content.replaceAll("{amatya-email}", contactUsJson.email)
                                    }
                                </div>
                            );
                        })
                    }
                </div>
                {
                    footerInfo.Copyright && <div className="footer-copyright">
                        {
                            footerInfo.Copyright
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default Footer;
